<div style="display: flex">
  <div class="main-div" (click)="toggleSidebar()">
  </div>
  <div class="navbar-top-products">
    @if (isLoading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span class="title">
          Sugestão encomenda
        </span>
        <img src="/assets/Icons/close-line.png" alt="close" style="height: 24px;cursor: pointer"
          (click)="toggleSidebar()">
        </div>
        <div class="tabs">
          <button class="tab" [class.active]="activeTab === 'semanal'" (click)="setActiveTab('semanal')">
            Semanal
          </button>
          <button class="tab" [class.active]="activeTab === 'quinzenal'" (click)="setActiveTab('quinzenal')">
            Quinzenal
          </button>
          <button class="tab" [class.active]="activeTab === 'mensal'" (click)="setActiveTab('mensal')">
            Mensal
          </button>
        </div>
        <div class="tab-content">
          @if (activeTab === 'semanal') {
            <div>
              <div class="btn-adicionar" (click)="addAllProductsToCart(products.semanal, 'semanal')">
                Adicionar todo o Top-20 ao carrinho
              </div>
              @for (product of products.semanal; track product) {
                <div class="list-products mobile-card"
                  style="display: flex; justify-content: space-between">
                  <div>
                    <span class="product-line">
                      <span class="only-mobile">Referencia:</span>
                      <span>
                        {{ product.reference}}
                      </span>
                    </span>
                    <span class="only-desktop">-</span>
                    <span class="product-line">
                      <span class="only-mobile label-produto">Produto:</span>
                      <span class="description">
                        {{ product.decription }}
                      </span>
                      @if (product.bonus.length > 0 || hasActiveQuantityCampaign(product)) {
                        <span
                          (click)="openProductBonus(product)" class="cursor-pointer bcg-ball">
                          <mat-icon svgIcon="discount" style="height: 20px; transform: scaleX(-1) rotate(90deg);"></mat-icon>
                        </span>
                      }
                    </span>
                  </div>
                  <span class="product-line">
                    <span class="only-mobile">Quantidade:</span>
                    <div class="d-flex flex-row plus-less">
                      <div class="less-btn">
                        <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                          (click)="removeQuantityClick(product, 'semanal')" />
                        </div>
                        <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
                          type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
                          (blur)="changeQuantity(input.value, product, product.productQuantity, 'semanal')" #input />
                          <div class="plus-btn">
                            <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                              (click)="addQuantityClick(product, 'semanal')" />
                            </div>
                          </div>
                        </span>
                      </div>
                    }
                  </div>
                }
                @if (activeTab === 'quinzenal') {
                  <div>
                    <div class="btn-adicionar" (click)="addAllProductsToCart(products.quinzenal, 'quinzenal')">
                      Adicionar todo o Top-20 ao carrinho
                    </div>
                    @for (product of products.quinzenal; track product) {
                      <div class="list-products mobile-card"
                        style="display: flex; justify-content: space-between">
                        <div>
                          <span class="product-line">
                            <span class="only-mobile">Referencia:</span>
                            <span>
                              {{ product.reference}}
                            </span>
                          </span>
                          <span class="only-desktop">-</span>
                          <span class="product-line">
                            <span class="only-mobile label-produto">Produto:</span>
                            <span class="description">
                              {{ product.decription }}
                            </span>
                            @if (product.bonus.length > 0 || hasActiveQuantityCampaign(product)) {
                              <span
                                (click)="openProductBonus(product)" class="cursor-pointer bcg-ball">
                                <mat-icon svgIcon="discount" style="height: 20px; transform: scaleX(-1) rotate(90deg);"></mat-icon>
                              </span>
                            }
                          </span>
                        </div>
                        <span class="product-line">
                          <span class="only-mobile">Quantidade:</span>
                          <div class="d-flex flex-row plus-less">
                            <div class="less-btn">
                              <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                                (click)="removeQuantityClick(product, 'quinzenal')" />
                              </div>
                              <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
                                type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
                                (blur)="changeQuantity(input.value, product, product.productQuantity, 'quinzenal')" #input />
                                <div class="plus-btn">
                                  <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                                    (click)="addQuantityClick(product, 'quinzenal')" />
                                  </div>
                                </div>
                              </span>
                            </div>
                          }
                        </div>
                      }
                      @if (activeTab === 'mensal') {
                        <div>
                          <div class="btn-adicionar" (click)="addAllProductsToCart(products.mensal, 'mensal')">
                            Adicionar todo o Top-20 ao carrinho
                          </div>
                          @for (product of products.mensal; track product) {
                            <div class="list-products mobile-card"
                              style="display: flex; justify-content: space-between">
                              <div>
                                <span class="product-line">
                                  <span class="only-mobile">Referencia:</span>
                                  <span>
                                    {{ product.reference}}
                                  </span>
                                </span>
                                <span class="only-desktop">-</span>
                                <span class="product-line">
                                  <span class="only-mobile label-produto">Produto:</span>
                                  <span class="description">
                                    {{ product.decription }}
                                  </span>
                                  @if (product.bonus.length > 0 || hasActiveQuantityCampaign(product)) {
                                    <span
                                      (click)="openProductBonus(product)" class="cursor-pointer bcg-ball">
                                      <mat-icon svgIcon="discount" style="height: 20px; transform: scaleX(-1) rotate(90deg);"></mat-icon>
                                    </span>
                                  }
                                </span>
                              </div>
                              <span class="product-line">
                                <span class="only-mobile">Quantidade:</span>
                                <div class="d-flex flex-row plus-less">
                                  <div class="less-btn">
                                    <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                                      (click)="removeQuantityClick(product, 'mensal')" />
                                    </div>
                                    <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
                                      type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
                                      (blur)="changeQuantity(input.value, product, product.productQuantity, 'mensal')" #input />
                                      <div class="plus-btn">
                                        <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                                          (click)="addQuantityClick(product, 'mensal')" />
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          <div class="tabsLab">
                            <button class="tab" [class.active]="activeTabLab === 'sugestoes'" (click)="setActiveTabLab('sugestoes')"
                              style="text-align-last: left;">
                              Destaques
                            </button>
                          </div>
                          <div class="tab-content">
                            @if (activeTabLab === 'sugestoes') {
                              <div>
                                <!-- Client requested to disable the following button -->
                                <!-- <div class="btn-adicionar" (click)="addAllProductsToCart(products.sugestoes, 'sugestoes')">
                                Adicionar produtos sugeridos ao carrinho
                              </div> -->
                              @for (product of products.sugestoes; track product) {
                                <div class="list-products mobile-card"
                                  style="display: flex; justify-content: space-between">
                                  <div>
                                    <span class="product-line">
                                      <span class="only-mobile">Referencia:</span>
                                      <span>
                                        {{ product.reference}}
                                      </span>
                                    </span>
                                    <span class="only-desktop">-</span>
                                    <span class="product-line">
                                      <span class="only-mobile label-produto">Produto:</span>
                                      <span class="description">
                                        {{ product.decription }}
                                      </span>
                                      @if (product.bonus.length > 0 || hasActiveQuantityCampaign(product)) {
                                        <span
                                          (click)="openProductBonus(product)" class="cursor-pointer bcg-ball">
                                          <mat-icon svgIcon="discount" style="height: 20px; transform: scaleX(-1) rotate(90deg);"></mat-icon>
                                        </span>
                                      }
                                    </span>
                                  </div>
                                  <span class="product-line">
                                    <span class="only-mobile">Quantidade:</span>
                                    <div class="d-flex flex-row plus-less">
                                      <div class="less-btn">
                                        <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                                          (click)="removeQuantityClick(product, 'sugestoes')" />
                                        </div>
                                        <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
                                          type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
                                          (blur)="changeQuantity(input.value, product, product.productQuantity, 'sugestoes')" #input />
                                          <div class="plus-btn">
                                            <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                                              (click)="addQuantityClick(product, 'sugestoes')" />
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>